export default {"src":"/_next/static/media/Vector-half-circle4.3ff1f76b.svg","height":89,"width":84,"blurWidth":0,"blurHeight":0};